import { IS_LOADING, ERROR} from "../../constants";

export { IS_LOADING, ERROR }

export const SET_HIDDEN_HOME_WIDGETS = "SET_HIDDEN_HOME_WIDGETS";